import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {  Container } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Header from "./components/Header";
import Home from "./pages/Home";
import ToolList from "./pages/ToolList";
import ToolView from "./pages/ToolView";
import ToolEdit from "./pages/ToolEdit";
import ToolAdd from "./pages/ToolAdd";
import app from "./firebase-config";
import "./index.css";
import theme from "./theme"; // Import the theme

import Page404 from "./pages/Page404"; // Import the 404 page

//import { initializeApp } from "firebase/app";

//const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

//const db = firebase.firestore();



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>    <ThemeProvider theme={theme}>

<Router>
        <Header />
        <Container>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tool/" element={<ToolList />} />
            <Route path="/tool/:toolid" element={<ToolView />} />
            <Route path="/tool/edit/:toolid" element={<ToolEdit />} />
            <Route path="/tool/add" element={<ToolAdd />} />
            <Route path="*" element={<Page404 />} /> {/* Wildcard route for 404 */}
          </Routes>
        </Container>
      </Router>
      </ThemeProvider>
        </React.StrictMode>
);
